export const formatDate = (date: string): string => {
  return new Date(date).toString();
};

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_MASK = "____-__-__";

export const YEAR_MONTH_FORMAT = "YYYY-MM";
export const YEAR_MONTH_MASK = "____-__";
